import { twinInboxPathParamsSchema, twinInboxActionInputSchema, twinInboxActionResponseSchema, twinInboxItemResponseSchema, twinInboxListQuerySchema, twinInboxListResponseSchema, twinInboxUpdateInputSchema, } from "../twin-inbox.js";
import { defineOperation } from "./http.js";
/** The person's connector Inbox; tenant handlers retain resource and source-action authority. */
export const TWIN_INBOX_OPERATIONS = {
    listInbox: defineOperation({
        operationId: "twin.inbox.list", method: "GET", path: "/api/twin/inbox", audience: "public",
        requiredScope: "twin.read", rateClass: "read",
        request: { query: twinInboxListQuerySchema }, response: { kind: "json", status: 200, schema: twinInboxListResponseSchema },
        sdk: { namespace: "twinInbox", method: "list" },
        swiftSdk: { method: "listInbox" },
        openapi: {
            summary: "List your connector Inbox",
            description: "The caller's incoming connector Inbox items (GitHub, Outlook mail, Slack, Calendar and the rest the web Inbox lists), newest first: what needs them (active) or what they've dealt with (done). Their own items and those of the shared mailboxes they can read, each narrowed to what a client lists; excludeSource leaves out a source; excludeOwnSource leaves out only the caller's own connection's items of one (Desk, the person's Gmail client, keeps a shared mailbox's).",
            responseDescription: "Inbox items", errors: [400, 403],
        },
    }),
    updateInboxItem: defineOperation({
        operationId: "twin.inbox.update", method: "PATCH", path: "/api/twin/inbox/{inboxItemId}", audience: "public",
        requiredScope: "twin.write", rateClass: "create",
        request: { params: twinInboxPathParamsSchema, body: twinInboxUpdateInputSchema }, response: { kind: "json", status: 200, schema: twinInboxItemResponseSchema },
        sdk: { namespace: "twinInbox", method: "update" },
        swiftSdk: { method: "updateInboxItem" },
        openapi: {
            summary: "Mark an Inbox item done, or back",
            description: "Marks an item done (dismissed) or puts it back in the Inbox (new). An item the caller can't read answers 404. When the item advertises an action that applies on done (archiving the email at its source), run that instead.",
            responseDescription: "Inbox item", errors: [400, 403, 404],
        },
    }),
    runInboxItemAction: defineOperation({
        operationId: "twin.inbox.actions.run", method: "POST", path: "/api/twin/inbox/{inboxItemId}/actions", audience: "public",
        requiredScope: "twin.write", rateClass: "create",
        request: { params: twinInboxPathParamsSchema, body: twinInboxActionInputSchema }, response: { kind: "json", status: 200, schema: twinInboxActionResponseSchema },
        sdk: { namespace: "twinInbox", method: "runAction" },
        swiftSdk: { method: "runInboxItemAction" },
        openapi: {
            summary: "Run an Inbox item's action at its source",
            description: "Runs one of the item's advertised actions at its source (archive_source, restore_source) and records a receipt. An action the item doesn't advertise answers 409.",
            responseDescription: "Action run", errors: [400, 403, 404, 409, 502],
        },
    }),
};
